export const connectedUserKeys = {
  all: ["connected-users"] as const,
};
